import { createBrowserRouter, Outlet } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useNoIndex } from './hooks/useNoIndex';
import { TopPage } from './routes/TopPage';
import { CreateGroupPage } from './routes/CreateGroupPage';
import { GroupHomePage } from './routes/GroupHomePage';
import { MatchInputPage } from './routes/MatchInputPage';
import { MatchDetailPage } from './routes/MatchDetailPage';
import { MembersPage } from './routes/MembersPage';
import { StatsPage } from './routes/StatsPage';
import { RulesPage } from './routes/RulesPage';
import { SettingsPage } from './routes/SettingsPage';
import { TermsPage } from './routes/TermsPage';
import { PrivacyPage } from './routes/PrivacyPage';
import { ContactPage } from './routes/ContactPage';
import { Body, Button, EmptyState, Screen } from './components/ui';

function NotFoundPage() {
  // SPA なのでサーバーは存在しないURLにも 200 とこの画面を返す（ソフト404）。
  // 放っておくと /foo でも /asdf でもインデックスの対象になりうる。
  useNoIndex();

  return (
    <Screen>
      <Body className="justify-center">
        <EmptyState
          title="ページが見つかりません"
          description="URLをご確認ください。共有URLは #t=… まで含めて開く必要があります。"
        />
        <Link to="/">
          <Button variant="ghost">トップへ戻る</Button>
        </Link>
      </Body>
    </Screen>
  );
}

/**
 * /g/ 配下をまとめて noindex にするためのレイアウトルート。path を持たないので
 * URL の形は変わらず、子ルートは今までどおり絶対パスで書ける。
 *
 * 8画面それぞれでフックを呼んでも同じことはできるが、あとから画面を足したときに
 * 書き忘れる。ここに入れておけば子は自動的に対象になる。
 */
function NoIndexRoutes() {
  useNoIndex();
  return <Outlet />;
}

/**
 * 画面遷移（§9.1）。
 * /g/:groupId 配下は CloudFront Function が index.html にリライトするため、
 * 直接URLを開いてもここに届く（03-web.yaml の SpaRouterFunction）。
 */
export const router = createBrowserRouter([
  { path: '/', element: <TopPage /> },
  { path: '/new', element: <CreateGroupPage /> },
  // 規約類は NoIndexRoutes の外に置く。/g/ 配下と違い、この3ページは
  // クロールされてほしい（フッターからの導線もそのため）。
  { path: '/terms', element: <TermsPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '/contact', element: <ContactPage /> },
  {
    element: <NoIndexRoutes />,
    children: [
      { path: '/g/:groupId', element: <GroupHomePage /> },
      { path: '/g/:groupId/matches/new', element: <MatchInputPage /> },
      { path: '/g/:groupId/matches/:matchId', element: <MatchDetailPage /> },
      { path: '/g/:groupId/matches/:matchId/edit', element: <MatchInputPage /> },
      { path: '/g/:groupId/members', element: <MembersPage /> },
      { path: '/g/:groupId/stats/:memberId', element: <StatsPage /> },
      { path: '/g/:groupId/rules', element: <RulesPage /> },
      { path: '/g/:groupId/settings', element: <SettingsPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
